import { render, staticRenderFns } from "./MtsCustomerPopup.vue?vue&type=template&id=0a90206d"
import script from "./MtsCustomerPopup.vue?vue&type=script&lang=js"
export * from "./MtsCustomerPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports